import React from "react";
import { useMediaQuery } from "react-responsive";

import { MEDIA_QUERIES } from "../../utils/namedConstants";
import { composeItemDefs } from "./composeItemDefs";
import { useSearchResults } from "../../context/DataContext";
import SearchResultsGlobal from "../SearchResultsGlobal/SearchResultsGlobal";
import SearchResultCardList from "../SearchResultCardList/SearchResultCardList";
import SearchResultsTable from "../SearchResultsTable/SearchResultsTable";
import isGlobalSearch from "./isGlobalSearch";
import { getSearchCollectionConfig } from "../../search";
import type { ResultColumn } from "../../search";

export type { ResultColumn };

export type SearchResultsProps = {
    collection: string;
};

export const SearchResults = ({ collection }: SearchResultsProps) => {
    const { results, facets } = useSearchResults();
    const collectionConfig = getSearchCollectionConfig(collection);
    const isLargeScreen = useMediaQuery({
        query: MEDIA_QUERIES.LARGE,
    });

    const isGlobal = isGlobalSearch(collection);
    const isCard = collectionConfig.displayMode === "card";
    const allItemDefs = composeItemDefs(collection);
    const coreColumnKeys = new Set(collectionConfig.coreColumnKeys);
    const facetLabels = new Set(facets.map((f) => f.name));
    const itemDefs = allItemDefs.filter((def) => {
        if (!collectionConfig.filterResultColumnsByFacet) return true;
        if (!def.label) return true;
        if (coreColumnKeys.has(def.columnKey)) return true;
        return facetLabels.has(def.label);
    });

    if (isGlobal) {
        return <SearchResultsGlobal itemDefs={itemDefs} />;
    }

    if (isCard) {
        return results.length ? (
            <SearchResultCardList itemDefs={itemDefs} />
        ) : null;
    }

    const maybeTable = isLargeScreen ? (
        <SearchResultsTable itemDefs={itemDefs} />
    ) : (
        <SearchResultCardList itemDefs={itemDefs} />
    );
    const maybeResults = results.length ? maybeTable : null;

    return maybeResults;
};

export default SearchResults;
